import sanitizeHtml from "sanitize-html";

export const createMarkup = (innerHtmlText: string) => ({
  __html: sanitizeHtml(innerHtmlText),
});
